import MenuItem from "@material-ui/core/MenuItem";

import { styled } from "@material-ui/core/styles";

export default styled(MenuItem)({
    '&.MuiListItem-root.Mui-selected, &.MuiListItem-root.Mui-selected:hover, &.MuiListItem-button:hover': {
        backgroundColor: '#F7EED7'
    }
});